module.exports = __webpack_public_path__ + "static/media/shorts_jeff.efcaf4f8.jpg";